
<template>
  <div style="margin-left:50px;">

    <el-form style="display: flex;flex-wrap: wrap;">

        <el-form-item label="方案名称:" style="display: flex;width: 33%;">
            <el-select
                placeholder="请选择方案名称"
                v-model="student"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="审批状态:" style="display: flex;width: 33%;" >
            <el-select
                placeholder="请选审批状态"
                v-model="student_s"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                v-for="item in getStudentsArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <!-- <el-form-item label="培训方式:" style="display: flex;width: 33%;" >
            <el-select
                placeholder="请选择培训方式"
                v-model="coursecancellationStatusInput"
                style="width: 100%"
                clearable
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
        </el-form-item>


        <el-form-item label="日期范围:" style="display: flex;width: 60%;">
            <el-date-picker
            style="width: 100%;"
            v-model="dateTimeList"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable>
            </el-date-picker>
        </el-form-item> -->

        
        <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
             <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
             <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="addBtns">添加培训方案</el-button> -->
        </div>

    </el-form>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
        <!-- <el-table-column prop="courseDate" label="日期">
          <template slot-scope="scope">
             <span>{{scope.row.courseDate.substring(0,10)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="courseStartTime" label="方案名称"></el-table-column>
        <el-table-column prop="courseEndTime" label="参训人完成状态"></el-table-column>
        <!-- <el-table-column prop="subjectName" label="审批人"></el-table-column> -->
        <el-table-column label="操作">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-around;">
                <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button>
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button> -->
                <el-button type="text" style="color:#00aaff;" @click="handleClickView('加入培训', scope.row)">加入培训</el-button>
              </div>
            </template>
        </el-table-column>
      </el-table>



    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
    </el-pagination>



    <el-dialog :title="ShowDlongTitle" :visible.sync="ShowDlong" :before-close="commitCler">
        
        <el-form ref="form" :model="form" label-width="80px">

            <el-form-item label="教师姓名:">
                <el-select
                    placeholder="请选择教师"
                    v-model="form.student"
                    style="width: 100%"
                    clearable
                    :disabled="ShowDlongDisabled"
                    filterable>
                    <el-option
                    v-for="item in getStudentsArr"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="审批人:">
              <el-select
                placeholder="请选审批人"
                v-model="form.student_s"
                style="width: 100%"
                clearable
                :disabled="ShowDlongDisabled"
                filterable>
                <el-option
                v-for="item in getStudentsArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
            </el-form-item>

           <el-form-item label="培训方式:">
            <el-select
                placeholder="请选择培训方式"
                v-model="form.coursecancellationStatusInput"
                style="width: 100%"
                clearable
                :disabled="ShowDlongDisabled"
                filterable >
                <el-option
                v-for="item in coursecancellationStatus"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
                >
                </el-option>
            </el-select>
           </el-form-item>

           <el-form-item label="日期范围:">
                <el-date-picker
                :disabled="ShowDlongDisabled"
                style="width: 100%;"
                v-model="form.dateTimeList"
                type="date"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable>
                </el-date-picker>
            </el-form-item>


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
          <el-button v-if="!ShowDlongDisabled" style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd">提交</el-button>
        </div>

    </el-dialog>
    


    <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler">
        
        <el-form ref="form" :model="form" label-width="100px">

            <el-form-item label="培训名称:">
                <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                </el-input>
            </el-form-item>

            <el-form-item label="任务创建人:">
              <el-select
                placeholder="请选任务创建人"
                v-model="Addform.CreatorName"
                style="width: 100%"
                clearable
                filterable>
                <el-option
                    v-for="item in getStudentsArr_s"
                    :key="item.id"
                    :value="item.id"
                    :label="item.realname">
                </el-option>
            </el-select>
            </el-form-item>

           <el-form-item label="参加培训人:">
            <el-select
                placeholder="请选择参加培训人"
                v-model="Addform.TrainerName"
                style="width: 100%"
                clearable
                filterable>
                 <el-option
                     v-for="item in coursecancellationStatus"
                     :key="item.id"
                     :value="item.id"
                     :label="item.realname" >
                 </el-option>
            </el-select>
           </el-form-item>

           <el-form-item label="培训内容:">
                <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                    <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                         style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                        <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                        <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                            <p>课节数:{{ item1.classNum }}</p>
                            <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                        </div>
                    </el-radio>
                </div>
           </el-form-item>

           <el-form-item label="资料上传:">
                <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="handleRemove"
                    :beforeUpload="beforeUpload"
                    :http-request="handleUpload"
                    :on-error="handleError"
                    :auto-upload="true"
                    show-file-list
                    :file-list="fileDataList"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
           </el-form-item>   

           <el-form-item label="审批人:">
                <el-select
                    placeholder="请选择审批人"
                    v-model="Addform.ApprovedName"
                    style="width: 100%"
                    clearable
                    filterable >
                    <el-option
                        v-for="item in coursecancellationStatus"
                        :key="item.id"
                        :value="item.id"
                        :label="item.realname" >
                    </el-option>
                </el-select>
           </el-form-item>


        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
        </div>

    </el-dialog>


    <el-dialog :title="titleDialog" width="70%" style="padding: 0px 10px;" :visible.sync="trainShowDlong" :before-close="traincommitCler">
        
                <div style="width: 100%;overflow-x: auto;">
                    <el-steps :active="activeStep" simple style="">
                        <el-step v-for="(itme,index) in newObj.dateList" :key="index" :title="itme" @click.native="handleStep(itme,index)"></el-step>
                    </el-steps>
                </div>
                

                <div style="width: 100%;height: 300px;flex-wrap: wrap;display: flex;overflow: auto;padding: 20px 0px;">
                    <el-card style="height: 100%;width: 350px;border-radius: 20px;margin-left: 10px;margin-top: 10px;margin-right: 12px;overflow: auto;"
                              v-for="(itme,index) in newObj.dataCardList[activeStep]" :key="index">

                        <div style="display: flex;margin-bottom: 20px;">
                            <div style="width: 93%;padding-left: 14px;font-size: 18px;font-weight: 900;line-height: 22px;">
                                任务{{
                                    index == 0 ? '一' : index === 1 ? '二' : index === 2 ? '三' : index === 3 ? '四' : index === 4 ? '五' :
                                    index == 5 ? '六' : index === 6 ? '七' : index == 7 ? '八' : index === 8 ? '九' : index === 9 ? '十' :
                                    index == 10 ? '十一' : index == 11 ? '十二' : index == 12 ? '十三' : index == 13 ? '十四' : index == 14 ? '十五' :
                                    index == 15 ? '十六' : index == 16 ? '十七' : index === 17 ? '十八' : index === 18 ? '十九' : index === 20 ? '二十' :
                                    index == 21 ? '二十一' : index === 22 ? '二十二' : index == 23 ? '二十四' : index == 24 ? '二十五' : index === 25 ? '二十六' :
                                    index === 27 ? '二十八' : index === 28 ? '二十九' : index == 29 ? '三十' : '三十一'
                                }}
                            </div>
                        </div> 

                        
                        <div style="display: flex;width: 100%;font-size:16px;margin-bottom: 10px;">
                            <div style="width: 120px;">培训名称：</div>
                            <div style="width: 80%;">{{ itme.taskName ? itme.taskName : '初始化培训名称' }}</div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:16px;margin-bottom: 10px;">
                            <div style="width: 120px;">培训内容：</div>
                            <div style="width: 80%;">{{ itme.taskDescribe ? itme.taskDescribe : '初始化培训内容' }}</div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:16px;margin-bottom: 10px;">
                            <div style="width: 120px;">相关资料：</div>
                            <div style="width: 80%; height: 50px;  overflow-y: auto;">
                                <div v-for="(itmes,index) in itme.fileDataList_s" :key="index">
                                    <a :href="itmes.url">{{itmes.name}}</a>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;width: 100%;font-size:16px;">
                            <div style="width: 160px;">任务完成状态：</div>
                            <div style="width: 80%;">{{ itme.reviewer }}</div>
                        </div>


                    </el-card>
                </div>


        <div slot="footer" class="dialog-footer">
          <div style="display: flex; position: absolute;right: 18%; margin-top: -5px;">
            <div style="padding-top:10px;margin-right:10px;">完成状态:</div>
            <div>
              <el-select  placeholder="请选择完成状态"  v-model="CreatorName"   style="width: 100%"  clearable  filterable>
                <el-option v-for="item in CreatorNameList"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
              </el-select>      
            </div>
          </div>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="trainAddcommitAdd">完成</el-button>
        </div>
    </el-dialog>


    <el-dialog :title="titleDialogTask" width="60%" style="padding: 0px 10px;" :visible.sync="trainShowDlongTask" :before-close="traincommitClerTask">
        <el-form ref="form" :model="formTask" label-width="100px"> 
            
            <el-form-item label="总结内容:">
              <el-input :autosize="{  minRows: 8, maxRows: 8 }"  type="textarea"  placeholder="请输入总结内容"  v-model="formTask.Taskcontent" maxlength="300" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="相关资料:">
                <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="handleRemoveTask"
                    :beforeUpload="beforeUploadTask"
                    :http-request="handleUploadTask"
                    :on-error="handleErrorTask"
                    :auto-upload="true"
                    show-file-list
                    :file-list="formTask.TaskDataFile"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-form-item>  
        </el-form> 
        <div slot="footer" class="dialog-footer">
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="traincommitClerTask">取消</el-button>
          <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSubTask">提交</el-button>
        </div>
    </el-dialog>



</div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import Vue from 'vue';
import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
var $Vue = Vue.prototype
import {  getStudentsType } from "@/api/fiveClassApi"
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import { isReturn } from "../utils/retnue";

export default defineComponent({

    setup(props, { attrs, slots, emit, expose }){
        let newObj = reactive({dateList:['第一天','第二天','第三天','第四天','第五天'],dataCardList:[[{},{},{},{},{}],[{}],[{}],[{}],[{}]]})
        let formTask = reactive( { Taskcontent:'',TaskDataFile:[] })
        let trainShowDlongTask = ref(false)
        let titleDialogTask = ref('任务记录')
        let trainShowDlong = ref(false)
        let titleDialog = ref('')
        let getStudentsArr = ref([])
        let getStudentsArr_s = ref([])
        let coursecancellationStatus = ref([])
        let student = ref('')
        let student_s = ref('')
        let coursecancellationStatusInput = ref('')
        let dateTimeList = ref([])
        let dataList = ref([])
        let requestParameters = reactive({pageSize:10,total:0,pageNum:0})
        let ShowDlong = ref(false)
        let ShowDlongDisabled = ref(false)
        let ShowDlongTitle = ref('编辑')
        let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:'', dateTimeList: '' })
        let AddShowDlong = ref(false)
        let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
        let planArr = ref([])
        let fileDataList = ref([])
        let activeStep = ref(0)
        let reviewerOptions = ref([{id:1, realname:'已完成'},{id:2, realname:'未完成'}])
        let CreatorName = ref('')
        let CreatorNameList = ref([ {id:1, realname:'已完成'},{id:2, realname:'未完成'} ])
        onMounted(()=>{
            handleAllApi()
        })

        watchEffect(() => {
            console.log(`Count is now 让子弹飞一会`);
        })


        const trainAddcommitAdd = () => {
            trainShowDlongTask.value  = true
        }

        const AddcommitSubTask = () => {
            trainShowDlongTask.value  = false
        }

        const traincommitClerTask = () =>{
            trainShowDlongTask.value  = false
        }

        const handleAllApi = () =>{
            getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
            getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
            coursecancellationStatus.value = [{ id: 1, realname : '唱' },{ id: 2, realname : '跳' },{ id: 3, realname : 'rap' }]
            dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: 'rap'  }]

            axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                headers:{
                    'authorization': sessionStorage.getItem('tokenInfo')
                },
            }).then(res => {
                isReturn(res.code)
                planArr.value = res.data.data.records
            }).catch(error => {
                console.error(error)
            })
        }

        const handleMessage = (message,type) =>{
             $Vue.$message({ message, type, duration: 500 });
        }


        const exportBtns = () =>{

        }
        const searchBtns = () =>{

        }
        const clearBtns = () =>{
            student.value = ""
            student_s.value = ""
            coursecancellationStatusInput.value = ""
            dateTimeList.value = []
        }
        const addBtns = () =>{
            AddShowDlong.value = true
        }

        const handleSizeChange = (size) =>{
            requestParameters.pageSize = size
        }
        const handleCurrentChange = (page) =>{
            requestParameters.pageNum = page
        }

        const handleClickView = (boom, edible)=>{
            let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
            form.student = courseStartTime
            form.student_s = courseEndTime
            form.coursecancellationStatusInput = subjectName
            form.dateTimeList = courseDate
            if(boom === '编辑'){
                ShowDlong.value = true
                ShowDlongDisabled.value = false
                ShowDlongTitle.value = '编辑'
            }
            if(boom === '详情'){
                ShowDlong.value = true
                ShowDlongDisabled.value = true
                ShowDlongTitle.value = '详情'
            }
            if(boom === '加入培训'){
                titleDialog.value = '培训方案'
                trainShowDlong.value = true
            }

        }


        const traincommitCler = () => {
            trainShowDlong.value = false
        }


        const commitCler = () =>{
            ShowDlong.value = false
            handleClrAll()
        }

        const commitAdd = () =>{
            ShowDlong.value = false
            handleClrAll()
        }

        const handleClrAll = () =>{
            form.student = ""
            form.student_s = ""
            form.coursecancellationStatusInput = ""
            form.dateTimeList = ""
        }

        const AddcommitCler = () =>{
            AddShowDlong.value = false
            handleClerAllDing()
        }

        const AddcommitAdd = () =>{
            console.log(Addform, 'Addform')
            console.log(fileDataList.value, 'fileDataList')


            AddShowDlong.value = false
            // setTimeout(()=>{
            //     handleClerAllDing()
            // },2000)
        }

        const AddcommitSub = () =>{
            console.log(Addform, 'Addform')
            console.log(fileDataList.value, 'fileDataList')


            AddShowDlong.value = false
            // setTimeout(()=>{
            //     handleClerAllDing()
            // },2000)
        }

        const handleClerAllDing = () =>{
            fileDataList.value = []
            Addform.TrainName = ""
            Addform.CreatorName = ""
            Addform.TrainerName = ""
            Addform.TrainingContent = ""
            Addform.ApprovedName = ""
        }

        const clickitem = (itme) =>{
            console.log(itme, 'itme')
        }

        const handleRemove = (file, fileList) =>{
            fileDataList.value = fileList
        }

        const handleRemoveTask = (file, fileList) =>{
            formTask.TaskDataFile = fileList
        }

        const getFileName = (name) => {
             return name.substring(name.lastIndexOf("."))
        }

        const beforeUpload = (file, fileList) =>{
            loadingUtils.startLoading()
            const fileExtensions =
                getFileName(file.name) === ".bmp" ||
                getFileName(file.name) === ".tif" ||
                getFileName(file.name) === ".gif" ||
                getFileName(file.name) === ".pcx" ||
                getFileName(file.name) === ".svg" ||
                getFileName(file.name) === ".psd" ||
                getFileName(file.name) === ".webp" ||
                getFileName(file.name) === ".apng" ||
                getFileName(file.name) === ".ai" ||
                getFileName(file.name) === ".avif" ||
                getFileName(file.name) === ".png" ||
                getFileName(file.name) === ".pdf"||
                getFileName(file.name) === ".mp4"||
                getFileName(file.name) === ".excel"||
                getFileName(file.name) === ".doc"||
                getFileName(file.name) === ".ppt"||
                getFileName(file.name) === ".mp3"||
                getFileName(file.name) === ".xls"||
                getFileName(file.name) === ".xlsx"||
                getFileName(file.name) === ".pptx"||
                getFileName(file.name) === ".docx"||
                getFileName(file.name) === ".txt"||
                getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                handleMessage("上传文件类不合格式!", 'warning')
            }
            if (!max20M) {
                handleMessage("上传文件类不合格式!", 'warning')
            }

            return fileExtensions && max20M
        }

        const beforeUploadTask = (file, fileList) =>{
            loadingUtils.startLoading()
            const fileExtensions =
                getFileName(file.name) === ".bmp" ||
                getFileName(file.name) === ".tif" ||
                getFileName(file.name) === ".gif" ||
                getFileName(file.name) === ".pcx" ||
                getFileName(file.name) === ".svg" ||
                getFileName(file.name) === ".psd" ||
                getFileName(file.name) === ".webp" ||
                getFileName(file.name) === ".apng" ||
                getFileName(file.name) === ".ai" ||
                getFileName(file.name) === ".avif" ||
                getFileName(file.name) === ".png" ||
                getFileName(file.name) === ".pdf"||
                getFileName(file.name) === ".mp4"||
                getFileName(file.name) === ".excel"||
                getFileName(file.name) === ".doc"||
                getFileName(file.name) === ".ppt"||
                getFileName(file.name) === ".mp3"||
                getFileName(file.name) === ".xls"||
                getFileName(file.name) === ".xlsx"||
                getFileName(file.name) === ".pptx"||
                getFileName(file.name) === ".docx"||
                getFileName(file.name) === ".txt"||
                getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                handleMessage("上传文件类不合格式!", 'warning')
            }
            if (!max20M) {
                handleMessage("上传文件类不合格式!", 'warning')
            }

            return fileExtensions && max20M
        }

        const handleUpload = (option) =>{
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = getFileNameUUID() + getFileName(option.file.name)
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()
                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        }
        const handleUploadTask = (option) =>{
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = getFileNameUUID() + getFileName(option.file.name)
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()
                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        }

        const handleError = () =>{
            loadingUtils.endLoading()
        }

        const handleErrorTask = () =>{
            loadingUtils.endLoading()
        }

        const handleStep = (itme,index) => {
            activeStep.value = index
        }

        return {
            reviewerOptions,
            handleStep,
            handleUpload,
            beforeUpload,
            handleError,
            handleUploadTask,
            CreatorNameList,
            getFileName,
            handleErrorTask,
            handleRemove,
            CreatorName,
            handleClerAllDing,
            fileDataList,
            clickitem,
            activeStep,
            handleRemoveTask,
            beforeUploadTask,
            formTask,
            AddcommitCler,
            AddcommitAdd,
            commitCler,
            commitAdd,
            handleMessage,
            getStudentsArr,
            getStudentsArr_s,
            coursecancellationStatus,
            student,
            student_s,
            planArr,
            coursecancellationStatusInput,
            dateTimeList,
            handleAllApi,
            exportBtns,
            searchBtns,
            clearBtns,
            addBtns,
            traincommitClerTask,
            dataList,
            handleClickView,
            handleSizeChange,
            handleCurrentChange,
            requestParameters,
            trainAddcommitAdd,
            ShowDlongTitle,
            ShowDlong,
            form,
            ShowDlongDisabled,
            handleClrAll,
            AddcommitSub,
            AddShowDlong,
            Addform,
            titleDialog,
            trainShowDlong,
            traincommitCler,
            titleDialogTask,
            trainShowDlongTask,
            AddcommitSubTask,
            newObj,

        }

    }

})


</script>

<style scoped  lang="less">

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

/deep/ .el-upload{
    width: 100% !important;
}

/deep/ .el-upload-dragger{
    width: 100% ;
}


/deep/ .el-step__icon{
    display: none;
}

/deep/ .is-simple{
    margin-right: 20px;
}

/deep/ .el-step__main{
    width: 80px;
}

/deep/ .el-steps--simple{
    background: #fff;
}


/deep/ .is-process{
    color: #09a3e0 !important;
}

/deep/ .is-finish{
    color: #000 !important; 
}

</style>


// WEBPACK FOOTER //
// src/initAssembly/TrainingEntrance.vue